/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';

export default (visualizationType :any, categorizers :string[], defaultCategorizersOnly :boolean) :boolean => {

    const { requirements } = visualizationType;

    if (!requirements) {
        return true;
    }

    const { categorizerAllowed, categorizerForbidden } = requirements;

    const allowedRules = !categorizerAllowed || !_.difference(categorizers, categorizerAllowed).length;

    const forbiddenRules = !categorizerForbidden || _.difference(categorizers, categorizerForbidden).length >= categorizers.length;

    const onlyRules = !requirements.categorizerDefaultOnly || defaultCategorizersOnly;

    return allowedRules && forbiddenRules && onlyRules;
};
